// action types
export const REMOVE_TAB = 'removeTab';

// mutation types

export const ADD_TAB = 'addTab';
export const CLOSE_OTHER_TABS = 'closeOthersTabs';
export const CLOSE_All_TABS = 'closeAllTabs';

export default {
  state: {
    appTabs: [],
  },
  getters: {
    /**
     * Get list of breadcrumbs for current page
     * @param state
     * @returns {*}
     */
    tabs(state) {
      return state.appTabs;
    },
  },
  actions: {
    /**
     * Set the breadcrumbs list
     * @param state
     * @param payload
     */
    [REMOVE_TAB](state, payload) {
      let newArr = state.getters.tabs;
      let indexOfTab = newArr.findIndex((v) => v.to === payload.to);
      newArr.splice(indexOfTab, 1);
      state.commit(ADD_TAB, newArr);
    },
    /**
     * Set the breadcrumbs list
     * @param state
     * @param payload
     */
    [ADD_TAB](state, payload) {
      let newArr = state.getters.tabs;
      const found = newArr.some((el) => el.to === payload.to);
      if (!found) newArr.unshift(payload);
      state.commit(ADD_TAB, newArr);
    },

    [CLOSE_OTHER_TABS](state, payload) {
      let newArr = state.getters.tabs;
      const found = newArr.filter((el) => el.to === payload.path);
      state.commit(CLOSE_OTHER_TABS, found);
    },

    [CLOSE_All_TABS](state) {
      state.commit(CLOSE_All_TABS);
    },
  },
  mutations: {
    [ADD_TAB](state, payload) {
      state.appTabs = payload;
    },
    [CLOSE_OTHER_TABS](state, payload) {
      state.appTabs = payload;
    },
    [CLOSE_All_TABS](state) {
      state.appTabs = [];
    },
  },
};
